module.exports = __webpack_public_path__ + "img/Angry_emoji-removebg-preview 1.a1c7798d.png";